import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57fa750c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "material-table" }
const _hoisted_2 = { class: "material-table__actions mb15" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("加入待选 >>")
const _hoisted_4 = { class: "label-wrap__line" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 限定： ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_table_wrapper = _resolveComponent("table-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(_component_a_input_search, {
          value: _ctx.keyword,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyword) = $event)),
          "enter-button": "",
          class: "w300",
          placeholder: "请输入材料名称关键字",
          onSearch: _ctx.search
        }, null, 8, ["value", "onSearch"])
      ]),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.add
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (_ctx.firstData && _ctx.firstData.repertotyName)
        ? (_openBlock(), _createBlock(_component_a_tag, {
            key: 0,
            color: "#F8982F"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.firstData?.repertotyName), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.companyId && _ctx.firstData && _ctx.firstData.repertotyName)
        ? (_openBlock(), _createBlock(_component_a_tag, {
            key: 1,
            color: "#F8982F"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.firstData?.supplierName), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_table_wrapper, {
      "row-key": "storageId",
      size: "small",
      border: true,
      ref: "tableRef",
      "data-source": _ctx.data,
      columns: _ctx.columns,
      onOnSelectionChange: _ctx.onSelectionChange,
      pagination: _ctx.pagination,
      tableHeight: _ctx.tableHeight,
      onOnTableChange: _ctx.onTableChange,
      loading: _ctx.loading,
      "data-config": { format: _ctx.dataFormat }
    }, {
      taxPrice: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_ctx.$filters.formatMoney(record.taxPrice)), 1)
      ]),
      _: 1
    }, 8, ["data-source", "columns", "onOnSelectionChange", "pagination", "tableHeight", "onOnTableChange", "loading", "data-config"])
  ]))
}